<template>
  <section class="body">
    <!-- Progress bar -->
    <div
      v-if="loadingFormData"
      class="text-center mb-2"
    >
      <b-progress
        :value="loadingFormDataValue"
        show-progress
        class="m-5"
      />
    </div>

    <b-form
      v-else
      @submit.prevent="submit"
    >
      <b-form-row class="mb-2 justify-content-center">
        <DateSiteModal
          :form="form.date"
        />
        <SiteModal :form="form" />
        <TargetGroupSiteModal :field-data="form.target_group" />
      </b-form-row>
      <b-form-row class="mb-2 justify-content-center">
        <button
          v-if="getSelectedInputs > 0"
          type="button"
          class="trashbtn mt-2 mr-2"
          @click="clearAllFields"
        >
          <b-icon-trash />
        </button>
        <div
          v-for="(selectedButton, key) in selectedBtns"
          :key="key"
        >
          <button
            class="selectedbtns mr-2 mt-2 bubblefontsize"
            type="button"
            @click="selectedButton.clickedBtn && selectedButton.clickedBtn()"
          >
            <span v-html="selectedButton.text" />
            <b-icon
              v-if="selectedButton.editable"
              class="ml-2 crossbtn"
              font-scale="1.5"
              icon="x"
              @click="
                selectedButton.clickedBtnDelete &&
                  selectedButton.clickedBtnDelete($event)
              "
            />
          </button>
        </div>
      </b-form-row>
      <b-form-row class="mb-2 justify-content-center">
        <b-button
          :disabled="disableRunBtn"
          type="submit"
          class="searchbutton ml-2"
          variant="primary"
          size="sm"
        >
          <b-icon
            v-if="!loadingSearchResults"
            icon="arrow-repeat"
          />
          {{ loadingSearchResults ? 'Arbetar...' : 'Kör' }}
        </b-button>
      </b-form-row>
      <b-form-row
        v-if="getTargetGroupCount() === 0"
        class="mb-2 justify-content-center"
      >
        <div class="text-center mb-2">
          <small
            class="text-danger"
          ><strong>Du måste välja målgrupp under Målgrupper / Mått</strong></small>
        </div>
      </b-form-row>
    </b-form>
    <!-- Results -->
    <template v-if="initFirstSearch">
      <!-- Show if loading results -->
      <div
        v-if="!hasData && loadingSearchResults"
        class="text-center mb-2"
      >
        <hr>
        <b-spinner
          variant="primary"
          type="grow"
          label="Spinning"
        />
        <div>
          <small class="text-muted">Laddar sökresultat...</small>
        </div>
      </div>

      <div>
        <!-- Show if search have hits -->
        <SiteResult
          v-show="hasData"
          @sort-only="submitSort"
          @exclude-rows="handleExcludeRows"
          :disabled="loadingSearchResults"
          :class="{ 'overlay-disabled': loadingSearchResults }"
        />

        <!-- Show if search have no hits -->
        <div
          v-if="!hasData && !loadingSearchResults"
          class="text-center"
        >
          <hr>
          <p>Inget sökresultat</p>
        </div>
      </div>
    </template>
    <SlowQueryModal 
      :show="showSlowQueryModal" 
      :loading="loadingExportResults" 
      @download="handleExportResults"
      @cancel="showSlowQueryModal = false" 
    />
    <ScheduleReportModal 
      :show="showScheduleReportModal" 
      :loading="loadingScheduleReport" 
      @submit="handleScheduleReportSubmit" 
      @cancel="showScheduleReportModal = false" 
    />
  </section>
</template>

<script>
import SlowQueryModal from "../../Shared/SlowQueryModal/SlowQueryModal.vue"
import ScheduleReportModal from "../../Shared/ScheduleReportModal/ScheduleReportModal.vue"
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/sv';
import DateSiteModal from '../Site/DateSiteModal';
import SiteModal from '@/components/Shared/SiteModal';
import TargetGroupSiteModal from '../Site/TargetGroupSiteModal';
import SiteResult from './SiteResult';
import { dateToyymmddFormat, addDays, isDateNotBetweenTwoDates, sleep, processSiteResults } from '../../../assets/js/utils.js';
//custom scripts
import { search, fetchFormFieldData } from '../../../assets/js/api.js';
import { bus } from '../../../main';
import { mapMutations, mapActions } from 'vuex';
import { downloadFile, createScheduledReportQuery } from '../../../assets/js/api.js';

export default {
  name: 'Site',
  components: {
    SlowQueryModal,
    ScheduleReportModal,
    SiteResult,
    DateSiteModal,
    SiteModal,
    TargetGroupSiteModal
  },
  data() {
    return {
      showScheduleReportModal: false,
      loadingScheduleReport: false,
      loadingExportResults:false,
      showSlowQueryModal: false,
      noMeasuresSelected: true,
      loadingFormData: true,
      loadingFormDataValue: 0,
      loadingFormDataMaxValue: 3,
      loadingSearchResults: false,
      initFirstSearch: false,
      formValidator: {
        dateFrom: true,
        dateTo: true,
      },
      form: {
        date: {
            datePicker: {
            weekdays: ['Må', 'Ti', 'On', 'To', 'Fr', 'Lö', 'Sö'],
            months: [
              'Januari',
              'Februari',
              'Mars',
              'April',
              'Maj',
              'Juni',
              'Juli',
              'Augusti',
              'September',
              'Oktober',
              'November',
              'December',
            ],
          },
          showDateSiteModal: false
        },
        columns: {
          options: [],
        },
        sites: {
          options: [],
          selected: [],
          showSiteModal: false,
          apiBodyGetter: "siteApiBody/getPayload",
          apiBodySetter: "siteApiBody/updatePayload"
        },
        target_group: {
          measurements: {
            options: [],
            selected: '',
          },
          showTargetGroupModal: false,
        }
      },
      selectedBtns: []
    };
  },
  computed: {
    allModalsClosed() {
      let allModalsClosed = false;
      if (
        !this.form.date.showDateSiteModal &&
        !this.form.sites.showSiteModal &&
        !this.form.target_group.showTargetGroupModal
      )
        allModalsClosed = true;
      return allModalsClosed;
    },
     disableRunBtn() {
       let disableRunBtn = false;
       if (this.loadingSearchResults) disableRunBtn = true;
       return disableRunBtn;
     },
    hasData() {
      return this.$store.state.siteResults.results.length > 0;
    },
    selectedColumns() {
      return this.$store.state.siteApiBody.payload.columns;
    },
    start_date: {
      get() {
        let startDate = this.$store.state.siteApiBody.payload.consumption_start_date;
        //setting date when no date is set
        if (!startDate && this.$store.state.systemInfo.publishedToDate) {
          let newStartDate = addDays(this.$store.state.systemInfo.publishedToDate, -2);
          this.$store.commit('siteApiBody/updateStartDate', newStartDate);
          return newStartDate;
        }
        //setting date from clicking the calendar in the interface.
        else return startDate;
      },
      set(value) {
        this.$store.commit('siteApiBody/updateStartDate', value);
      },
    },
    end_date: {
      get() {
        let endDate = this.$store.state.siteApiBody.payload.consumption_end_date;
        //setting date when no date is set
        if (!endDate) {
          this.$store.commit(
            'siteApiBody/updateEndDate',
            this.$store.state.systemInfo.publishedToDate,
          );
          return this.$store.state.systemInfo.publishedToDate;
        }
        //setting date from clicking the calendar in the interface.
        return endDate;
      },
      set(value) {
        this.$store.commit('siteApiBody/updateEndDate', value);
      },
    },
    payload(){
      return this.$store.getters["siteApiBody/getPayload"]
    },
    getSelectedInputs() {
      let selectedInputs = this.selectedBtns.length;
      return selectedInputs;
    },
  },
  watch: {
    "$store.state.systemInfo.publishedToDate"(pubToDate){
      this.setDefaultStartDateEndDate(pubToDate)
    },
    payload: {
      handler() {
        let query = this.$store.state.siteApiBody.payload
        let selectedBtns = [];
        selectedBtns.push(
          {
            text: `<span class="font-weight-bold">Konsumtionsdatum:</span> ${query.consumption_start_date} - ${query.consumption_end_date}`,
            editable: false,
            clickedBtn: () => {
              this.form.date.showDateSiteModal = true;
            }
          })
        if (query.site_id) {
          let chosenText = query.site_id.length > 1 ? "valda" : "vald";
          selectedBtns.push({
            text: `<span class="font-weight-bold">Site:</span> (${query.site_id.length} ${chosenText})`,
            clickedBtn: () => {
              this.form.sites.showSiteModal = true;
            }
          });
        }
        let numberOfStoredTargets = this.getTargetGroupCount();
        if (numberOfStoredTargets > 0) {
          let chosenText = numberOfStoredTargets > 1 ? "valda" : "vald";
          selectedBtns.push({
            text: `<span class="font-weight-bold"> Målgrupp / Mått </span> ${numberOfStoredTargets} ${chosenText}`,
            editable: true,
            clickedBtn: () => {
              this.form.target_group.showTargetGroupModal = true;
            },
            clickedBtnDelete: event => {
              event.stopPropagation();
              localStorage.removeItem("measuresSite");
              this.$store.commit('siteApiBody/updateMeasures', []);
            }
          });
        }
        this.selectedBtns = selectedBtns;
      },     
      deep: true
    },
  },
  beforeDestroy() {
    // Clean up by removing the event listener when the component is destroyed
    document.removeEventListener("keyup", this.onKeyUp);
  },
  mounted() {
    if (!this.$store.state.systemInfo.fullAccess) {
      this.$router.push('/');
    }
    this.$store.commit('systemInfo/updateAnyFormFieldsLoaded', true);
    document.addEventListener("keyup", this.onKeyUp);
  },
  async created() {
    //Fetch sites from api
    let sitesResponse = await fetchFormFieldData('Sites', 'Site');
    if (sitesResponse.statusCode) {
      this.$bvToast.toast(sitesResponse.errorMessage, {
        title: 'Varning',
        variant: 'warning',
        solid: true,
        autoHideDelay: 3000,
      });
    } else {
      for (let index in sitesResponse) {
        let site = {
          text: sitesResponse[index].site_name,
          value: sitesResponse[index].site_id,
          selected: true,
        };
        this.form.sites.options.push(site);
      }
      this.loadingFormDataValue = 66;
    }
    let siteValues = this.form.sites.options.map(s => s.value)
    this.updateSiteIds(siteValues);
    //Fetch measures types from api
    let measureTypeResponse = await fetchFormFieldData('MeasureTypes', 'Site');
    if (measureTypeResponse.statusCode) {
      this.$bvToast.toast(measureTypeResponse.errorMessage, {
        title: 'Varning',
        variant: 'warning',
        solid: true,
        autoHideDelay: 3000,
      });
    } else {
      for (let index in measureTypeResponse) {
        let measure = {
          text: measureTypeResponse[index].display_name,
          value: measureTypeResponse[index].measure_type,
          showReachSelector: measureTypeResponse[index].show_reach_selector,
          ...measureTypeResponse[index].show_reach_selector && {
            reachAbsHeader: measureTypeResponse[index].reach_abs_header,
            reachRelHeader: measureTypeResponse[index].reach_rel_header,
          },
        };
        this.form.target_group.measurements.options.push(measure);
      }
      this.form.target_group.measurements.selected = measureTypeResponse[0].measure_type;

      this.loadingFormDataValue = 100;
    }
    let pubDate = this.$store.state.systemInfo.publishedToDate
    if(pubDate)
      this.setDefaultStartDateEndDate(pubDate);
    // Sleep so that the progress bar has time to finnish
    await sleep(600);

    this.loadingFormData = false;
  },
  methods: {
    ...mapMutations('siteReachApiBody', ['emptyQueryKeys']),
    ...mapActions(['resetReachSiteState']),

    async handleScheduleReportSubmit(reportname) {
      this.loadingScheduleReport = true
      try {
          let payload = {...this.$store.state.siteApiBody };
          
          // kör frågan här
          await createScheduledReportQuery(reportname,payload);

          this.$bvToast.toast("Körningen är schemalagd, du får ett mail när den är klar.", {
              title: "Schemalgd körning",
              variant: "success",
              solid: true,
              autoHideDelay: 5000,
          })
      } catch (error) {
          this.loadingScheduleReport = false
          this.showScheduleReportModal = false
          this.$bvToast.toast("Det gick inte schemalägga rapportkörningen", {
              title: "Serverfel",
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
          })
      } finally {
          this.loadingScheduleReport = false
          this.showScheduleReportModal = false
      }


    },
    async handleExportResults() {
      try {
        this.loadingExportResults = true;
        let payload = { ...this.$store.state.siteApiBody };
        await downloadFile('QuerySiteData/DownloadExport', payload);
      } catch (error) {
        console.error('Failed to export results:', error);
        this.$bvToast.toast('Ett fel uppstod vid export av data. Försök igen senare.', {
          title: 'Export misslyckades', 
          variant: 'danger',
          solid: true
        });
      } finally {
        this.loadingExportResults = false;
        this.showSlowQueryModal = false;
      }
    },

    getTargetGroupCount() {
      let storedTargets = localStorage.getItem("measuresSite")
        ? JSON.parse(localStorage.getItem("measuresSite"))
        : [];

      return storedTargets != null
        ? storedTargets.length
        : 0;
    },
    clearAllFields(){

        //reset dates
        this.$store.commit('siteApiBody/updateEndDate',this.$store.state.systemInfo.publishedToDate);

        let newStartDate = addDays(this.$store.state.systemInfo.publishedToDate, -2);
        
        this.$store.commit('siteApiBody/updateStartDate', newStartDate);
        //reset sites
        let siteValues = this.form.sites.options.map(s => s.value)
        this.updateSiteIds(siteValues);
        //reset site measures
        localStorage.removeItem("measuresSite");
        this.$store.commit('siteApiBody/updateMeasures', []);
    },
    isFromDateDisabled(date) {
      let disableDate = isDateNotBetweenTwoDates(
        date,
        new Date(this.$store.state.systemInfo.publishedFromDate),
        new Date(this.$store.state.systemInfo.publishedToDate),
      );
      return disableDate;
    },
    isEndDateDisabled(date) {
      let disableDate = isDateNotBetweenTwoDates(
        date,
        new Date(this.$store.state.systemInfo.publishedFromDate),
        new Date(this.$store.state.systemInfo.publishedToDate),
      );
      return disableDate;
    },
    formatDate(date) {
      return dateToyymmddFormat(date);
    },
    setDefaultStartDateEndDate(pubDate){
      let newStartDate = addDays(pubDate, -2);
      this.$store.commit('siteApiBody/updateStartDate', newStartDate);
      this.$store.commit("siteApiBody/updateEndDate", pubDate);
    },
    updateSiteIds(value) {
      this.$store.commit('siteApiBody/updateSiteIds', value);
    },
    async submit() {
      if (
        this.$store.state.siteApiBody.payload.consumption_start_date >
        this.$store.state.siteApiBody.payload.consumption_end_date
      ) {
        this.$bvToast.toast('Från-datum får inte vara större än till-datum.', {
          title: 'Ej giltig sökperiod',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          bodyOutputType: 'trustedHtml',
        });
        return;
      }
      if (
        this.$store.state.siteApiBody.payload.consumption_start_date <
        this.$store.state.systemInfo.publishedFromDate
      ) {
        this.$bvToast.toast(
          'Perioden får inte starta före ' + this.$store.state.systemInfo.publishedFromDate + '.',
          {
            title: 'Ej giltig sökperiod',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
            bodyOutputType: 'trustedHtml',
          },
        );
        return;
      }
      if (
        this.$store.state.siteApiBody.payload.consumption_end_date >
        this.$store.state.systemInfo.publishedToDate
      ) {
        this.$bvToast.toast(
          'Till-datum får inte vara större än senast publicerings datum som är ' +
            this.$store.state.systemInfo.publishedToDate +
            '.',
          {
            title: 'Ej giltig sökperiod',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
            bodyOutputType: 'trustedHtml',
          },
        );
        return;
      }
      if (this.getTargetGroupCount() === 0) return;
      if (
        this.$store.state.siteApiBody.payload.consumption_start_date.length > 0 &&
        this.$store.state.siteApiBody.payload.consumption_end_date.length > 0
      ) {
        this.formValidator.dateFrom = true;
        this.formValidator.dateTo = true;
        this.initFirstSearch = true;
        this.loadingSearchResults = true;
        let apiBody = this.$store.state.siteApiBody;

        if (apiBody.payload.measures.length == 0) {
          //Om measures saknas vid en reload, ta från localStorage (om det finns)
          if (localStorage.getItem('measuresSite')) {
            this.measuresSite = JSON.parse(localStorage.measuresSite);

            this.$store.commit('siteApiBody/updateMeasures', this.measuresSite);

            let measureSiteNames = [];
            for (let i = 0; i < this.measuresSite.length; i++) {
              measureSiteNames.push(this.measuresSite[i].measure_name);
            }

            this.$store.commit('targetGroups/defineSiteSearchTargetGroups', measureSiteNames);
          }
        }

        bus.$emit('searching', 713);

        if (!this.$store.state.siteApiBody.isOnSortSearch) {
          this.$store.commit('siteApiBody/updateSortBy', 'measure_1');
          this.$store.commit('siteApiBody/updateSortDirection', 'DESC');
        }

        // eslint-disable-next-line no-console
        let siteResults = null;
        this.resetReachSiteState();

        this.$store.commit('siteApiBody/updateExcludedRows', []);


        this.$store.commit('siteResults/updateResults', []);
        this.$store.commit('siteResults/updateResultFields', []);

// get querycost
        
      await search('QuerySiteData/QueryCost', apiBody)
            .then(async queryCost => {
              if(queryCost.queryClass == 'Normal') {
                        await search('QuerySiteData', apiBody)
                          .then((response) => {
                            this.$store.commit('siteResults/updateRowCount', response.info.total_row_count);
                            siteResults = response;
                            this.emptyQueryKeys();
                            processSiteResults(siteResults, this.$store);
                          })
                          .catch(() => {
                            this.loadingSearchResults = false;
                            this.$bvToast.toast('Okänt serverfel vid hämtning av sökresultat', {
                              title: 'Fel',
                              variant: 'danger',
                              solid: true,
                              autoHideDelay: 10000,
                            });
                            this.$store.commit('siteResults/updateResults', []);
                            this.$store.commit('siteResults/updateResultFields', []);
                            return;
                          });
            } else if (queryCost.queryClass == 'RowLimitExceeded') {
                  this.loadingSearchResults = false;
                  this.$store.commit('searchResults/updateResults', []);
                  this.$store.commit('searchResults/updateResultFields', []);
                  this.showSlowQueryModal = true;
                  return;

              } else if (queryCost.queryClass == 'Schedule') {
                      this.loadingSearchResults = false;
                      this.$store.commit('searchResults/updateResults', []);
                      this.$store.commit('searchResults/updateResultFields', []);
                      this.showScheduleReportModal = true;
                      return;

              } else if (queryCost.queryClass == 'Forbidden') {
                      this.loadingSearchResults = false;
                      this.$bvToast.toast('Körningen är för omfattande', {
                        title: 'Fel',
                        variant: 'danger',
                        solid: true,
                        autoHideDelay: 10000,
                      });
                      this.$store.commit('searchResults/updateResults', []);
                      this.$store.commit('searchResults/updateResultFields', []);
                      return;
              } 
          })


        this.loadingSearchResults = false;
      } else {
        this.formValidator.dateFrom = this.$store.state.siteApiBody.payload.start_date.length > 0;
        this.formValidator.dateTo = this.$store.state.siteApiBody.payload.end_date.length > 0;
      }
    },
    onKeyUp(event) {
      if (event.key === "Enter" && this.allModalsClosed) {
        this.submit();
      }
    },
    async submitSort() {
      this.loadingSearchResults = true;
      const apiBody = this.$store.state.siteApiBody;
      
      // Store current selections before the sort
      const selectedRows = this.$store.state.siteResults.results
        .filter(item => item.valda)
        .map(item => item.rowNum);
      
      try {
        const response = await search('QuerySiteData', apiBody);
        this.$store.commit('siteResults/updateRowCount', response.info.total_row_count);
        
        // Process results but preserve selections
        processSiteResults(response, this.$store);
        
        // Restore selections based on rowNum
        selectedRows.forEach(rowNum => {
          this.$store.commit('siteResults/select', rowNum);
        });
        
      } catch (error) {
        this.$bvToast.toast('Okänt serverfel vid hämtning av sökresultat', {
          title: 'Fel',
          variant: 'danger',
          solid: true,
          autoHideDelay: 10000,
        });     
        this.$store.commit('siteResults/updateResults', []);
        this.$store.commit('siteResults/updateResultFields', []);
      } finally {
        this.loadingSearchResults = false;
      }
    },
    async handleExcludeRows(rows) {
      this.loadingSearchResults = true;
      const apiBody = this.$store.state.siteApiBody;
      
      // Update excluded rows in store
      this.$store.commit('siteApiBody/updateExcludedRows', rows);
      
      // Store current total row count before the update
      const previousTotalRowCount = this.$store.state.siteResults.totalRowCount;
      
      try {
        const response = await search('QuerySiteData', apiBody);
        
        // Update total row count to maintain excluded rows state
        this.$store.commit('siteResults/updateRowCount', previousTotalRowCount);
        
        // Process results but keep the total row count
        processSiteResults(response, this.$store);
        
      } catch (error) {
        this.$bvToast.toast('Okänt serverfel vid hämtning av sökresultat', {
          title: 'Fel',
          variant: 'danger',
          solid: true,
          autoHideDelay: 10000,
        });     
        this.$store.commit('siteResults/updateResults', []);
        this.$store.commit('siteResults/updateResultFields', []);
      } finally {
        this.loadingSearchResults = false;
      }
    },
  },
};
</script>

<style scoped>
>>> label{
  margin-bottom: 0.25rem
}
.wildcardCbxText {
  font-size: small;
}
.supportTextNoAnswers {
  font-size: 0.8em;
  font-style: italic;
}
</style>
